export const URL_ORIGIN = "https://www.thinkchina.sg/";
export const URL_ORIGIN_ALTERNATE =
  "android-app://com.ps.bt/https/www.thinkchina.sg/";
export const URL_ORIGIN_TWITTER = "com.sph.bt://url=https://www.thinkchina.sg/";
export const FORMAT_DETECTION = "telephone=no";
export const OG_SITE_NAME =
  "ThinkChina - Big Reads, Opinions & Columns on China";
export const TWITTER_CARD = "summary_large_image";
export const ARTICLE_PUBLISHER = "https://www.facebook.com/ThinkChina/";
